export default "__VITE_ASSET__DlkxTVt$__"